import * as React from 'react';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { useHistory, Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';

export default function TopActions(props) {
  const history = useHistory();
  const goBack = () => history.goBack();

  return (
    <Card sx={{ p: { xs: 1.5, sm: 2 }, mb: 2 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        alignItems={{ sm: 'center' }}
        flexWrap="wrap"
      >
        {/* Back button */}
        <Button size="small" variant="outlined" startIcon={<ArrowBackIcon />} onClick={goBack} sx={{ minWidth: 0 }}>
          Kthehu
        </Button>

        <Stack direction="row" spacing={1} flexWrap="wrap">
          {props.newHref && (
            <Link to={props.newHref} className={props.newVisible} style={{ textDecoration: 'none' }}>
              <Button size="small" variant="contained" startIcon={<AddIcon />}>Shto</Button>
            </Link>
          )}

          {props.addNew && (
            <Button size="small" variant="contained" startIcon={<AddIcon />} onClick={props.addNew}>Shto</Button>
          )}

          {props.save && (
            <Button size="small" variant="contained" color="success" startIcon={<SaveIcon />} onClick={props.save} className={props.saveVisible}>
              Ruaj
            </Button>
          )}

          {props.addAllWorkers && (
            <Button size="small" variant="outlined" startIcon={<AddIcon />} onClick={props.addAllWorkers}>
              Shto të gjithë
            </Button>
          )}

          {props.downloadContract && (
            <IconButton size="small" onClick={props.downloadContract} title="Shkarko">
              <DownloadIcon />
            </IconButton>
          )}

          {props.uploadContract && (
            <IconButton size="small" onClick={props.uploadContract} title="Ngarko">
              <UploadIcon />
            </IconButton>
          )}

          {props.exportToCsv && (
            <Button size="small" variant="outlined" startIcon={<DownloadIcon />} onClick={props.exportToCsv}>CSV</Button>
          )}
        </Stack>

        {/* Month/year filters */}
        {props.monthYearSelect && (
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ sm: 'center' }} sx={{ flex: 1 }}>
            <Box sx={{ flex: 1 }}>
              <select
                value={props.month}
                onChange={(e) => props.setSearchQuery(e, 'month')}
                style={{
                  width: '100%',
                  padding: '6px 10px',
                  borderRadius: 6,
                  border: '1px solid #D0D5DD',
                  fontSize: '0.8rem',
                  outline: 'none',
                  background: '#fff',
                }}
              >
                {(props?.months || []).map((m) => (
                  <option key={m.no} value={m.no}>{m.name}</option>
                ))}
              </select>
            </Box>
            <TextField
              type="number"
              size="small"
              value={props.year}
              onChange={(e) => props.setSearchQuery(e, 'year')}
              sx={{ width: { xs: '100%', sm: 100 } }}
            />
            <Button size="small" variant="contained" startIcon={<SearchIcon />} onClick={() => props.search()}>
              Kërko
            </Button>
          </Stack>
        )}
      </Stack>
    </Card>
  );
}
